export const cardStatusConstants = {
  GET_CARDSTATUS_REQUEST: "GET_CARDSTATUS_REQUEST",
  GET_CARDSTATUS_SUCCESS: "GET_CARDSTATUS_SUCCESS",
  GET_CARDSTATUS_FAILURE: "GET_CARDSTATUS_FAILURE",
  GET_CARDSTATUS_RESET: "GET_CARDSTATUS_RESET"
};
